import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";


export function passwordMatching(controlName: string, matchingControlName: string): ValidatorFn {
  return function (controls: AbstractControl): ValidationErrors | null {
    if (controls) {
      const newPassword = controls.get(controlName)!.value;
      const confirmPassword = controls.get(matchingControlName)!.value;
      if (controls.get(matchingControlName)!.errors && !controls.get(matchingControlName)!.errors?.['confirmedValidator']) {
        return null;
      }
      if (newPassword !== confirmPassword) {
        controls.get(matchingControlName)?.setErrors({ confirmedValidator: true });
        return { mismatchedPassword: true };
      } else {
        controls.get(matchingControlName)?.setErrors(null);
      }
    }
    return null;
  };
}

export function NoWhitespaceValidator(control: AbstractControl): ValidationErrors | null {

  if ((control.value as string)?.trim().length == 0) {
    return { whitespace: true }
  }
  return null;
}

export function atleastOneRolePermission(control: AbstractControl): ValidationErrors | null {
  if ((control.value as Array<any>).every((x: any) => !x.permissionIds))
    return { atleastOneRolePermission: true }
  return null;
}

export function PhoneNumberPatterValidator(control: AbstractControl): ValidationErrors | null {

  if ((control.value as string)?.trim().length == 0) {
    return { whitespace: true }
  }
  return null;
}


export function uniqueAndExistingAgentsValidator(existingAgents: string[]): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    const records: any = (formArray as FormGroup).controls['agents'];
    records.controls.forEach((control: any, index: number) => {
      const email = control.value.email;
      const isDuplicate = records.controls.some((control: any, i: number) => i !== index && control.value.email && control.value.email === email);
      console.log(isDuplicate);
      if (isDuplicate) {
        control.setErrors({ duplicateEmail: true });
      } else {
        control.setErrors(null);
        if (existingAgents.find((x: any) => x.email?.toLowerCase() === email?.toLowerCase())) {
          control.setErrors({ existingEmail: true });
        } else {
          control.setErrors(null);
        }
      }
    });
    return null;
  };
}

export function uniqueAndExistingBusinessValidator(existingBusinesses: string[]): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    const records: any = (formArray as FormGroup).controls['business'];
    records.controls.forEach((control: any, index: number) => {
      const email = control.value.email;
      const businessName = control.value.name;

      const isDuplicate = records.controls.some((control: any, i: number) => i !== index && control.value.email && control.value.email === email && control.value.name && control.value.name === businessName);
      if (isDuplicate) {
        control.setErrors({ duplicateBusinessDetails: true });
      } else {
        control.setErrors(null);
        if (existingBusinesses.find((x: any) => x.email?.toLowerCase() === email?.toLowerCase() && x.name?.toLowerCase() === businessName?.toLowerCase())) {
          control.setErrors({ existingBusinessDetails: true });
        } else {
          control.setErrors(null);
        }
      }
    });
    return null;
  };
}
